'use client';

import { FilterOption, SortBlock } from '@/fo/ui/product/layout/catalog';

export interface ArticleTypeSortProps {
  sortByFilters: FilterOption[];
  selectedSortByFilters: string;
  onSortChange: (option: FilterOption | null) => void;
  className?: string;
}

/** Обёртка SortBlock для фильтра по типу (новости/акции), колбэк при смене варианта */
export function ArticleTypeSort({
  sortByFilters,
  selectedSortByFilters,
  onSortChange,
  className
}: ArticleTypeSortProps) {
  return (
    <SortBlock
      className={className}
      sortByFilters={sortByFilters}
      selectedSortByFilters={selectedSortByFilters}
      onSortChange={onSortChange}
    />
  );
}
